import { Box, Grid2, InputLabel, MenuItem, Pagination, Paper, Select, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { useAuditLogListMutation, useLogDropDownQuery } from "../../redux/AuditLog/AuditLog.api";
import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import MUIButton from "../../reusable_components/components/MUIButton";
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import dayjs from "dayjs";
import MUICancelButton from "../../reusable_components/components/MuiCancelButton";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { TableLoader } from "../../reusable_components/components/TableLoader";
import Dropdown from "../../reusable_components/components/Dropdown";
import SearchIconLg from "../../assets/Icons/SearchIcon";
import CalendarIcon from "../../assets/Icons/CalendarIcon";
import MuiDatePicker from "../../reusable_components/components/MuiDatePicker"


const AuditLog = () => {
    const commonFilter = JSON.parse(localStorage.getItem('commonsearchfilter'))
    const [searchKeyword, setSearchKeyword] = useState(commonFilter?.AuditLog?.email || "")

    const { Snackbar } = useContext(SnackbarContext)

    const [fromDate, setFromDate] = useState(null)
    const [toDate, setToDate] = useState(null)
    const [auditLogDataList, setAuditLogDataList] = useState()
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [count, setCount] = useState()
    const [selectedLogType, setSelectedLogType] = useState("")
    const [logDropdownList, setLogDropdownList] = useState([])
    const [showTableLoader, setShowTableLoader] = useState(false)
    const [shouldFetch, setShouldFetch] = useState(false);

    // APIs 
    const [auditLogList] = useAuditLogListMutation()
    const { data: logDropDown } = useLogDropDownQuery()

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    // const handleChangeRowsPerPage = (event) => {
    //     setRowsPerPage(+event.target.value);
    //     setPage(0);
    // };

    const handleLogType = (value) => {
        setSelectedLogType(value)
    }

    const handleFromDate = (date) => {
        setFromDate(date)

        if (toDate && toDate <= date) {
            setToDate(null)
        }
    }

    const handleToDate = (date) => {
        setToDate(date)
    }

    const getNextDay = (fromDate) => {
        if (!fromDate) {
            return null
        }

        return dayjs(fromDate)?.add(1, 'day')
    }

    const handleSearchKeywordChange = (e) => {
        const value = e.target.value
        setSearchKeyword(value)
        setPage(1)

        const currentFilter = JSON.parse(localStorage.getItem('commonsearchfilter')) || {};

        // 2. Update the clientId inside dashbord
        const updatedFilter = {
            ...currentFilter,
            auditLogs: {
                ...currentFilter.email,
                email: value
            }
        };

        // 3. Store the updated object back in localStorage
        localStorage.setItem('commonsearchfilter', JSON.stringify(updatedFilter));
    }

    const { Profile } = useSelector((state) => state.common)
    const id = Profile?.profile?.emailId

    const viewAduitLogList = async () => {
        try {
            const payload = {
                email: searchKeyword || "",
                fromDate: fromDate ? dayjs(fromDate)?.format('YYYY-MM-DD') : null,
                logType: selectedLogType.toString() || "",
                page: (page - 1) || 0,
                size: rowsPerPage || 10,
                toDate: toDate ? dayjs(toDate)?.format('YYYY-MM-DD') : null,
            }
            setShowTableLoader(true)
            const response = await auditLogList(payload).unwrap()
            setShowTableLoader(false)
            setAuditLogDataList(response?.response?.event)
            setCount(response?.response?.totalCount)

        } catch (error) {
            Snackbar("Network error", 'error')
            setShowTableLoader(false)
        }
    }

    useEffect(() => {
        viewAduitLogList()
        if (logDropDown) {
            setLogDropdownList(logDropDown?.response?.logTypeList);
        }

    }, [rowsPerPage, page, logDropDown, logDropdownList, searchKeyword])

    useEffect(() => {
        if (shouldFetch) {
            viewAduitLogList();
            setShouldFetch(false)
        }
    }, [page, shouldFetch]);

    const filteredTableDatas = auditLogDataList?.filter((item) => {
        return (
            (item?.auditLogId?.toString()?.startsWith(searchKeyword)) ||
            (item?.email?.toLowerCase()?.startsWith(searchKeyword?.toLowerCase()))
        )
    })

    return (
        <Box className="container">
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography className="title">Audit Logs</Typography>

                <Grid2 item sx={{ width: '23%' }}>
                    <TextField
                        className="textfields"
                        slotProps={{
                            input: {
                                startAdornment: <SearchIconLg style={{ paddingRight: '5px' }} />
                            }
                        }}
                        placeholder="Search By Email"
                        value={searchKeyword}
                        onChange={handleSearchKeywordChange}
                    />
                </Grid2>
            </div>

            <Paper sx={{ width: '100%', overflow: 'auto', border: '1px solid #E9EAEB', marginTop: '10px' }} elevation={0}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell colSpan={100} sx={{ padding: '10px' }}>
                                <div style={{ display: 'flex', gap: '25px' }}>
                                    <Grid2 item sx={{ width: '20%' }}>
                                        <InputLabel className='inputlabels'>Activity Type </InputLabel>
                                        <Dropdown
                                            className='dropdown'
                                            displayEmpty
                                            placeholder='Select Status Type'
                                            value={selectedLogType}
                                            onChange={handleLogType}
                                            valueKey='logTypeId'
                                            labelKey='logType'
                                            options={logDropdownList}
                                        />
                                    </Grid2>

                                    <Grid2 item sx={{ width: '20%' }}>
                                        <InputLabel className='inputlabels'>From Date </InputLabel>
                                        <MuiDatePicker
                                            slots={{
                                                openPickerIcon: CalendarIcon
                                            }}
                                            slotProps={{
                                                textField: {
                                                    size: 'small',
                                                    placeholder: 'Choose From Date',
                                                    InputProps: { sx: { borderRadius: '10px', height: '35px' } }
                                                }
                                            }}
                                            value={fromDate}
                                            onChange={handleFromDate}
                                            sx={{
                                                '& .MuiInputBase-input': {
                                                    fontSize: '14px'
                                                },
                                                "& .MuiSvgIcon-root": {
                                                    fontSize: '20px'
                                                }
                                            }}
                                            format="DD-MM-YYYY"
                                        />
                                    </Grid2>

                                    <Grid2 item sx={{ width: '20%' }}>
                                        <InputLabel className='inputlabels'>To Date </InputLabel>
                                        <MuiDatePicker
                                            slots={{
                                                openPickerIcon: CalendarIcon
                                            }}
                                            slotProps={{
                                                textField: {
                                                    size: 'small',
                                                    placeholder: 'Choose To Date',
                                                    InputProps: { sx: { borderRadius: '10px', height: '35px' } }
                                                }
                                            }}
                                            value={toDate}
                                            onChange={handleToDate}
                                            sx={{
                                                '& .MuiInputBase-input': {
                                                    fontSize: '14px'
                                                },
                                                "& .MuiSvgIcon-root": {
                                                    fontSize: '20px'
                                                }
                                            }}
                                            format="DD-MM-YYYY"
                                            minDate={getNextDay(fromDate) || null}
                                            disabled={!fromDate}
                                        />
                                    </Grid2>

                                    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                                        <MUIButton
                                            title="View"
                                            onClick={() => {
                                                setPage(1);
                                                setShouldFetch(true);
                                            }}
                                            sx={{ backgroundColor: '#7F56D9' }}
                                        />                                    </Box>
                                </div>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className='tableHeadersCell'>Log Number</TableCell>
                            <TableCell className='tableHeadersCell'>Date/Time</TableCell>
                            <TableCell className='tableHeadersCell'>Activity Type</TableCell>
                            <TableCell className='tableHeadersCell'>Email ID</TableCell>
                            <TableCell className='tableHeadersCell' >Activity Description</TableCell>
                        </TableRow>
                    </TableHead>
                    {!showTableLoader ? (
                        filteredTableDatas?.length > 0 ? (
                            <TableBody>
                                {filteredTableDatas?.map((row, index) => {
                                    return (
                                        <TableRow
                                            key={index}
                                            sx={{
                                                backgroundColor: index % 2 === 1 ? '#FAFAFA' : 'inherit',
                                                '&:hover': { backgroundColor: '#f1f1f1' },
                                            }}
                                        >
                                            <TableCell className='tableBodyCell' sx={{ width: '12%' }}>{row.auditLogId}</TableCell>
                                            <TableCell className='tableBodyCell' sx={{ width: '17%' }}>
                                                {row.createdDate ? dayjs(row.createdDate).format('DD/MM/YYYY hh:mm:ss A') : "NA"}
                                            </TableCell>
                                            <TableCell className='tableBodyCell' sx={{ width: '19%' }}>{row.activityType}</TableCell>
                                            <TableCell className='tableBodyCell' sx={{ width: '21%' }}> {row.email}</TableCell>
                                            <TableCell className='tableBodyCell' sx={{
                                                whiteSpace: 'normal',
                                                wordBreak: 'break-word',
                                                width: '100%',
                                                maxWidth: '100%',
                                            }}> {row.activityDescription}</TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        ) : (<TableBody>
                            <TableRow>
                                <TableCell colSpan={5}>
                                    <Typography className="emptydatas">No Data Found</Typography>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                        )
                    ) : (
                        <TableRow>
                            <TableCell colSpan={8}>
                                <Box className='tableloader'>
                                    <TableLoader />
                                </Box>
                            </TableCell>
                        </TableRow>
                    )}
                    {Math.ceil(count / rowsPerPage) > 1 && (
                        <TableRow>
                            <TableCell colSpan={100}>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <MUICancelButton
                                        title='Previous'
                                        startIcon={<ArrowBackIcon sx={{ color: page === 1 ? '#a2a2a2' : '#414651' }} />}
                                        onClick={() => handleChangePage(null, page - 1)}
                                        disabled={page === 1}
                                        sx={{ height: '36px' }}
                                    />

                                    <Pagination
                                        page={page}
                                        onChange={handleChangePage}
                                        count={Math.ceil(count / rowsPerPage) || 0}
                                        siblingCount={1}
                                        boundaryCount={1}
                                        shape="rounded"
                                        hidePrevButton
                                        hideNextButton
                                    />

                                    <MUICancelButton
                                        title='Next'
                                        startIcon={<ArrowForwardIcon sx={{ color: page === Math.ceil(count / rowsPerPage) ? '#a2a2a2' : '#414651' }} />}
                                        onClick={() => handleChangePage(null, page + 1)}
                                        disabled={page === Math.ceil(count / rowsPerPage)}
                                        sx={{ height: '36px' }}
                                    />
                                </div>
                            </TableCell>
                        </TableRow>
                    )}
                </Table>
            </Paper>
            {/* <TablePagination
                className="tablepagination"
                rowsPerPageOptions={[10, 20, 30]}
                component="div"
                count={count || 0}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            /> */}
        </Box>
    )
}
export default AuditLog;